import "scripts/templates/page.about.js";
import { registerBundle } from "scripts/lib/register-bundle.js";
registerBundle("template.page.about");
